import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { TtTextField } from '@23/ui-react'

import If, { Then, Else } from '../If/If'

import './ReduxFormSimpleFieldComponent.scss'

const getErrorMessage = (error, warning) => {
  if (error) {
    return <div className="error">{error}</div>
  }

  if (warning) {
    return <div>{warning}</div>
  }

  return null
}

const getId = (form, input, type) => {
  if (type === 'radio') {
    return `${form}-${input.name}-${input.value}`
  }

  return `${form}-${input.name}`
}

const ReduxFormSimpleFieldComponent = (props) => {
  const {
    input,
    label,
    type,
    customInputProps,
    customFieldStyles,
    placeholder,
    elementRef: ref,
    forceHideError,
    isDropdown,
    theme,
    className,
    meta: { touched, error, warning, form, active },
  } = props

  const classes = classnames(
    'redux-form-simple-field-component',
    className,
    { 'is-invalid': !forceHideError && touched && error },
    { 'is-dropdown': isDropdown },
    { [theme]: theme }
  )
  const id = getId(form, input, type)
  const elementProps = { id, ...input, ...customInputProps, placeholder, ref }

  return (
    <div className={classes} style={customFieldStyles}>
      {label && <label htmlFor={id}>{label}</label>}
      <div>
        <If condition={type === 'textarea'}>
          <Then>
            <textarea {...elementProps} />
          </Then>
          <Else>
            <If condition={type === 'tt'}>
              <Then>
                <TtTextField
                  type="text"
                  size="medium"
                  {...elementProps}
                  onTtChange={input.onChange ?? (() => {})}
                />
              </Then>
              <Else>
                <input type={type} {...elementProps} />
              </Else>
            </If>
          </Else>
        </If>
        <If condition={!forceHideError && touched && !active}>
          {getErrorMessage(error, warning)}
        </If>
      </div>
    </div>
  )
}

ReduxFormSimpleFieldComponent.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string,
  className: PropTypes.string,
  customInputProps: PropTypes.object,
  customFieldStyles: PropTypes.object,
  elementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  placeholder: PropTypes.string,
  forceHideError: PropTypes.bool,
  isDropdown: PropTypes.bool,
  theme: PropTypes.oneOf(['pv-input-primary', 'pv-input-secondary']),
}

ReduxFormSimpleFieldComponent.defaultProps = {
  customInputProps: {},
  forceHideError: false,
  isDropdown: false,
}

export default ReduxFormSimpleFieldComponent
